import initBogoInfoModal from "components/jiffy/home/bogo_info_modal/bogo-info-modal";

document.addEventListener("DOMContentLoaded", () => {
  initBogoInfoModal();
});
